import React from "react";
import { Arrow } from "../../assets/images/index";
import './back-button.scss'

interface BackButtonProps {
  onClickBack?: () => void;
  className?: string;
  style?: React.CSSProperties; // Add style prop
}

export default function Index({
  onClickBack,
  className,
  style,
}: BackButtonProps) {
  return (
    <button
      className={`back-btn ${className}`}
      onClick={onClickBack}
      style={style}
    >
      <img src={Arrow} alt="Arrow" />
    </button>
  );
}
